"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.secondaryButtons = void 0;
var common_1 = require("./common");
exports.secondaryButtons = [
    {
        props: { variant: 'secondaryDefault' },
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common_1.buttonsCommon), { color: "var(--secondary-500, ".concat(theme.palette.secondary.main, ")"), border: "1px solid var(--secondary-500, ".concat(theme.palette.secondary.main, ")"), '&:hover': {
                    backgroundColor: "var(--secondary-300, ".concat(theme.palette.secondary.light, ")"),
                }, '&:focus': {
                    backgroundColor: "var(--secondary-300, ".concat(theme.palette.secondary.light, ")"),
                }, '&:active': {
                    color: "var(--text-light, ".concat(theme.palette.text.light, ")"),
                    backgroundColor: "var(--secondary-700, ".concat(theme.palette.secondary.dark, ")"),
                    border: "1px solid var(--secondary-700, ".concat(theme.palette.secondary.dark, ")"),
                }, '&:disabled': {
                    backgroundColor: "var(--background-white, ".concat(theme.palette.backgrounds.white, ")"),
                    color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
                    border: "1px solid var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
                } }));
        },
    },
    {
        props: { variant: 'secondaryHC' },
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common_1.buttonsCommon), { color: "var(--text-light, ".concat(theme.palette.text.light, ")"), border: "1px solid var(--neutrals-white, ".concat(theme.palette.neutrals.white, ")"), '&:hover': {
                    color: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")"),
                    backgroundColor: "var(--secondary-300, ".concat(theme.palette.secondary.light, ")"),
                    border: "1px solid var(--neutrals-white, ".concat(theme.palette.neutrals.white, ")"),
                }, '&:focus': {
                    color: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")"),
                    backgroundColor: "var(--secondary-300, ".concat(theme.palette.secondary.light, ")"),
                    border: "1px solid var(--neutrals-white, ".concat(theme.palette.neutrals.white, ")"),
                }, '&:active': {
                    color: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")"),
                    backgroundColor: "var(--neutrals-300, ".concat(theme.palette.neutrals.primary, ")"),
                    border: "1px solid var(--neutrals-white, ".concat(theme.palette.neutrals.white, ")"),
                }, '&:disabled': {
                    color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
                    border: "1px solid var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
                } }));
        },
    },
];
